import { getOidcStorageInfo } from './getOidcStorageInfo';

export async function getAccessToken({
  authority,
  client_id,
}: {
  authority: string;
  client_id: string;
}) {
  const storageData = await getOidcStorageInfo({ authority, client_id });
  return storageData?.access_token ?? null;
}
